import { render, staticRenderFns } from "./VlPaginationItem.vue?vue&type=template&id=2188edce&scoped=true&"
import script from "./VlPaginationItem.vue?vue&type=script&lang=js&"
export * from "./VlPaginationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2188edce",
  null
  
)

export default component.exports